import { render, staticRenderFns } from "./DashboardPayschedules.vue?vue&type=template&id=2db5c3f7&scoped=true&"
import script from "./DashboardPayschedules.vue?vue&type=script&setup=true&lang=js&"
export * from "./DashboardPayschedules.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DashboardPayschedules.vue?vue&type=style&index=0&id=2db5c3f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5c3f7",
  null
  
)

export default component.exports